var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"registration-success-modal","size":"lg","hide-header":"","hide-footer":"","centered":"","modal-class":"registration-success-modal text-center"},on:{"hide":_vm.hideModal}},[_c('p',[_c('b',[_vm._v("Registration complete!")]),_c('br'),_vm._v("\n    An email will be sent to "+_vm._s(_vm.email)+", after verification.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }